import type { Block, BlockType } from "@alchimie/shared";

let counter = 0;
function newId(prefix: string): string {
  counter++;
  return `${prefix}-${Date.now().toString(36)}-${counter}`;
}

export function createBlock(type: BlockType): Block {
  switch (type) {
    case "HERO":
      return {
        id: newId("hero"),
        type: "HERO",
        props: {
          title: "Titre principal",
          subtitle: "Un sous-titre qui clarifie la promesse en une phrase.",
        },
        style: { textAlign: "center", paddingTop: "96px", paddingBottom: "96px" },
      };
    case "RICH_TEXT":
      return {
        id: newId("text"),
        type: "RICH_TEXT",
        props: { doc: { type: "doc", content: [{ type: "paragraph", content: [{ type: "text", text: "Écrivez ici votre paragraphe." }] }] } },
        style: { paddingTop: "32px", paddingBottom: "32px" },
      };
    case "VIDEO":
      return {
        id: newId("video"),
        type: "VIDEO",
        props: { assetId: "", autoplay: false, loop: false },
        style: { paddingTop: "32px", paddingBottom: "32px" },
      };
    case "AUDIO":
      return {
        id: newId("audio"),
        type: "AUDIO",
        props: { assetId: "" },
        style: { paddingTop: "24px", paddingBottom: "24px" },
      };
    case "PDF":
      return {
        id: newId("pdf"),
        type: "PDF",
        props: { assetId: "", showPreview: true, downloadable: true },
        style: { paddingTop: "24px", paddingBottom: "24px" },
      };
    case "IMAGE":
      return {
        id: newId("image"),
        type: "IMAGE",
        props: { assetId: "" },
        style: { paddingTop: "24px", paddingBottom: "24px" },
      };
    case "BENEFITS":
      return {
        id: newId("benefits"),
        type: "BENEFITS",
        props: {
          heading: "Ce que vous allez gagner",
          columns: 3,
          items: [
            { icon: "✨", title: "Bénéfice 1", body: "À expliciter." },
            { icon: "✦", title: "Bénéfice 2", body: "À expliciter." },
            { icon: "✶", title: "Bénéfice 3", body: "À expliciter." },
          ],
        },
        style: { paddingTop: "64px", paddingBottom: "64px" },
      };
    case "TESTIMONIALS":
      return {
        id: newId("testimonials"),
        type: "TESTIMONIALS",
        props: {
          heading: "Ils nous font confiance",
          items: [
            { author: "Cliente A.", quote: "Témoignage à compléter." },
          ],
        },
        style: { paddingTop: "64px", paddingBottom: "64px" },
      };
    case "FAQ":
      return {
        id: newId("faq"),
        type: "FAQ",
        props: {
          heading: "Questions fréquentes",
          items: [{ q: "Une question ?", a: "Sa réponse." }],
        },
        style: { paddingTop: "48px", paddingBottom: "48px" },
      };
    case "PRICING":
      return {
        id: newId("pricing"),
        type: "PRICING",
        props: { ctaLabel: "Rejoindre maintenant" },
        style: { paddingTop: "64px", paddingBottom: "64px" },
      };
    case "CTA":
      return {
        id: newId("cta"),
        type: "CTA",
        props: { label: "Je rejoins maintenant", action: "buy" },
        style: { textAlign: "center", paddingTop: "80px", paddingBottom: "80px" },
      };
    case "DIVIDER":
      return {
        id: newId("divider"),
        type: "DIVIDER",
        props: {},
        style: { paddingTop: "32px", paddingBottom: "32px" },
      };
    case "SPACER":
      return {
        id: newId("spacer"),
        type: "SPACER",
        props: { height: "64px" },
      };
    case "COLUMNS":
      return {
        id: newId("columns"),
        type: "COLUMNS",
        props: { columns: [[], []] },
        style: { paddingTop: "32px", paddingBottom: "32px" },
      };
    case "CUSTOM_HTML":
      return {
        id: newId("html"),
        type: "CUSTOM_HTML",
        props: { html: "<div style=\"padding:48px;text-align:center;font-family:serif\">Votre HTML ici</div>" },
      };
  }
}
